/* Live price update as the quantity field changes, matching the standard
   WooCommerce-style "dynamic pricing" UX: the displayed unit price updates
   to whichever bulk-pricing tier the current quantity falls into, and that
   tier's row is highlighted in the table. Reads the price straight from the
   already-rendered table row (rather than recomputing it) so it can never
   drift out of sync with what the table itself shows. */
(function () {
  function initBulkPricing(wrapper) {
    var sectionId = wrapper.dataset.sectionId;
    if (!sectionId) return;

    var quantityInput = document.getElementById('Quantity-' + sectionId);
    var priceWrapper = document.getElementById('price-' + sectionId);
    if (!quantityInput || !priceWrapper) return;

    var priceTargets = priceWrapper.querySelectorAll(
      '.price-item--sale, .price-item--regular'
    );
    if (!priceTargets.length) return;

    // "-X%" badge next to the price - kept in sync with whichever tier the
    // current quantity falls into, sourced from each row's own data-percent
    // so it can never drift from the table itself.
    var discountBox = priceWrapper.querySelector('.save__disoucnt');
    var percentTarget = priceWrapper.querySelector('.sale__save--percent');

    var rows = Array.prototype.slice.call(
      wrapper.querySelectorAll('.bulk-pricing-table__row')
    );
    if (!rows.length) return;

    // Cache each row's own rendered price text once, up front - this is the
    // source of truth, so the live-updated price always matches the table.
    var tiers = rows.map(function (row) {
      var priceCell = row.querySelector('.bulk-pricing-table__price');
      return {
        row: row,
        min: parseInt(row.dataset.minQty, 10) || 0,
        max: row.dataset.maxQty ? parseInt(row.dataset.maxQty, 10) : null,
        priceText: priceCell ? priceCell.textContent.trim() : null,
        percent: parseInt(row.dataset.percent, 10) || 0,
      };
    });

    function findTier(quantity) {
      for (var i = 0; i < tiers.length; i++) {
        var tier = tiers[i];
        if (quantity >= tier.min && (tier.max === null || quantity <= tier.max)) {
          return tier;
        }
      }
      return null;
    }

    function update() {
      var quantity = parseInt(quantityInput.value, 10);
      if (!quantity || quantity < 1) return;

      var tier = findTier(quantity);

      rows.forEach(function (row) {
        row.classList.remove('bulk-pricing-table__row--active');
      });

      if (!tier || !tier.priceText) return;

      tier.row.classList.add('bulk-pricing-table__row--active');
      priceTargets.forEach(function (el) {
        el.textContent = tier.priceText;
      });

      if (percentTarget) {
        percentTarget.textContent = tier.percent;
      }
      if (discountBox) {
        discountBox.style.display = tier.percent > 0 ? '' : 'none';
      }
    }

    quantityInput.addEventListener('input', update);
    quantityInput.addEventListener('change', update);
    // Also catch the quantity-input component's own +/- buttons, which
    // update the input's value programmatically rather than via typing.
    var quantityWrapper = quantityInput.closest('quantity-input');
    if (quantityWrapper) {
      quantityWrapper.addEventListener('click', function () {
        setTimeout(update, 0);
      });
    }

    update();
  }

  document.querySelectorAll('.bulk-pricing-table-wrapper').forEach(initBulkPricing);
})();
